class ProductUpsellNew extends HTMLElement {
    static name = 'product-upsell-new';
    constructor() {
        super();
    }


    connectedCallback() {
        console.log('[ProductUpsellNew] connectedCallback');
        this.packageSelector();
        
        // Agregar un pequeño delay para asegurar que el DOM esté completamente cargado
        setTimeout(() => {
            console.log('[ProductUpsellNew] init after delay');
            this.initDeliveryPackageSelector();
            // Inicializar listeners del modal del chiller
            this.initChillerModal();
        }, 100);
    }

    get packages() {
        return document.querySelectorAll('.product__block__upsell-product_package .upsell-package');
    }

    get price() {
        return document.querySelector('.product__price');
    }

    get form() {
        return document.querySelector('form.shopify-product-form');
    }

    get modelSelector() {
        return document.querySelectorAll('.product-selector-type_tabs .tab');
    }

    get button() {
        return document.querySelector('button[id="btn-addcart-smg"]');
    }

    get addButtons() {
        return document.querySelectorAll('product-add-button');
    }

    get mediaThumbs() {
        return document.querySelectorAll('.media__thumb__holder .media__thumb__wrapper .media__thumb');
    }

    get mediaSlides() {
        return document.querySelectorAll('.product__grid--slides .flickity-slider .product__media.flickity-cell');
    }

    packageSelector() {
        setTimeout(() => {
            if(this.packages.length > 0) {
                this.packages.forEach((elm) => {
                    if(elm.classList.contains('active') && elm.getAttribute('available') == 'true') {
                        this.button.setAttribute('style', 'display: block');
                        if(this.addButtons.length > 0) {
                            this.addButtons.forEach((el) => {
                                el.setAttribute('style', 'display: none');
                            });
                        }
                    }

                    if(elm.classList.contains('active')) {
                        let getTotalPrices = document.querySelector('.product-selector-type_tabs .tab.active'),
                        handleActive = getTotalPrices.getAttribute('handle');
                        if(getTotalPrices.getAttribute('type') == 'yes') {
                            this.price.innerHTML = `
                                <span data-product-price>${getTotalPrices.getAttribute('total_price')}</span>
                            `;

                        } else {
                            this.price.innerHTML = `
                                <span data-product-price>${getTotalPrices.getAttribute('price')}</span>
                            `;
                        }
                    }

                    //clicking models
                    /*elm.addEventListener('click', (evt) => {
                        setTimeout(() => {
                            let packageActive = document.querySelector('.product-selector-type_tabs .tab.active'),
                            handle = packageActive.getAttribute('handle');

                            this.getImage(handle);

                        }, 500);
                    });*/
                });
            }

            let currentURL = new URL(window.location.href),
            params = currentURL.searchParams;

            if(params.has('model') && params.has('type')) {
                let model = params.get('model'),
                type = params.get('type'),
                metafields = JSON.parse(document.querySelector('script[id="'+model+'"]').textContent);

                document.querySelector('.product__block__upsell-product_package .upsell-package:not([prd="'+model+'"])').classList.remove('active');
                document.querySelector('.product__block__upsell-product_package .upsell-package[prd="'+model+'"]').classList.add('active');
                    
                document.querySelector('.product-selector-type_tabs .tab:not([type="'+type+'"])').classList.remove('active');
                document.querySelector('.product-selector-type_tabs .tab[type="'+type+'"]').classList.add('active');

                document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('handle', metafields.package_handle);
                document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('price', metafields.package_price);
                document.querySelector('.product-selector-type_tabs .tab[type="no"]').setAttribute('price', metafields.model_price);
                document.querySelector('.product-selector-type_tabs .tab[type="no"]').setAttribute('handle', metafields.model_handle);

                if(type == 'no') {
                    document.querySelector('.product-selector-type_tabs_body').style.display = 'none';
                    /*document.querySelector('.product__price').innerHTML = `
                    <span data-product-price>${metafields.model_price}</span>
                    `;*/

                    //this.getImage(metafields.model_handle);
                } else {
                    /*document.querySelector('.product__price').innerHTML = `
                    <span data-product-price>${metafields.package_price}</span>
                    `;*/
                    document.querySelector('.product-selector-type_tabs_body').style.display = 'block';
                    let getTotalPrices = document.querySelector('.product-selector-type_tabs .tab.active'),
                    handleActive = metafields.package_handle;

                    //this.getImage(handleActive);
                }

                //window.onload = (event) => {
                    //setTimeout(() => {
                        document.querySelector('.product__block__upsell-product_package .upsell-package.active').click();
                    //}, 1000);
                //};
            } else {
                let packageActive = document.querySelector('.product__block__upsell-product_package .upsell-package.active'),
                id = packageActive.getAttribute('prd'),
                metafields = JSON.parse(document.querySelector('script[id="'+id+'"]').textContent);

                document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('handle', metafields.package_handle);
                document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('price', metafields.package_price);
                document.querySelector('.product-selector-type_tabs .tab[type="no"]').setAttribute('price', metafields.model_price);
                document.querySelector('.product-selector-type_tabs .tab[type="no"]').setAttribute('handle', metafields.model_handle);

                if(metafields.model_price == '' || metafields.model_price == null || metafields.model_price == undefined) {
                    metafields.model_price = metafields.package_price;
                }

                //precio fuera
                /*document.querySelector('.product__price').innerHTML = `
                    <span data-product-price>${metafields.model_price}</span>
                `;*/

                //this.getImage(metafields.model_handle);

                //window.onload = (event) => {
                    //setTimeout(() => {
                        document.querySelector('.product__block__upsell-product_package .upsell-package.active').click();
                    //}, 1000);
                //};
            }


            this.modelSelector.forEach((_item) => {
                _item.addEventListener('click', (evt) => {
                    this.modelSelector.forEach((itm) => {
                        itm.classList.remove('active');
                    });
                    evt.currentTarget.classList.add('active');

                    let variant = evt.currentTarget.getAttribute('variant_id'),
                    id = evt.currentTarget.getAttribute('packages_id'),
                    type = evt.currentTarget.getAttribute('type'),
                    handle = evt.currentTarget.getAttribute('handle'),
                    getURL = new URL(window.location.href),
                    params = getURL.searchParams;

                    if(evt.currentTarget.getAttribute('type') == 'yes') {
                        document.querySelector('input[name="id"]').value = variant;
                        document.querySelector('input[name="id"]').setAttribute('data-productid', id);
                        document.querySelector('input[name="product-id"]').value = id;
                        document.querySelector('.product__price').innerHTML = `
                            <span data-product-price>${evt.currentTarget.getAttribute('price')}</span>
                        `;
                        document.querySelector('.product__price').dataset.variantId = variant

                        /*if(document.querySelectorAll('.product__price__main .product__price--off').length > 0) {
                            document.querySelector('.product__price__main .product__price--off').style.display = 'none';
                        }*/
                        
                        document.querySelector('.product-selector-type_tabs_body').style.display = 'block';

                    } else {
                        document.querySelector('input[name="id"]').value = id;
                        document.querySelector('input[name="id"]').setAttribute('data-productid', id);
                        document.querySelector('input[name="product-id"]').value = id;
                        document.querySelector('.product-selector-type_tabs_body').style.display = 'none';
                        document.querySelector('.product__price').innerHTML = `
                            <span data-product-price>${evt.currentTarget.getAttribute('price')}</span>
                        `;
                        document.querySelector('.product__price').dataset.variantId = variant

                        /*if(document.querySelectorAll('.product__price__main .product__price--off').length > 0) {
                            document.querySelector('.product__price__main .product__price--off').style.display = 'block';
                        }*/
                    }

                    getURL.searchParams.delete('model');
                    getURL.searchParams.delete('type');
                    getURL.searchParams.set('model', document.querySelector('.product__block__upsell-product_package .upsell-package.active').getAttribute('prd'));
                    getURL.searchParams.set('type', document.querySelector('.product-selector-type_tabs .tab.active').getAttribute('type'));
                
                    window.history.pushState(null,null, getURL);

                    //this.getImage(handle);
                });
            });

        }, 1000);
    }

    async getProductData(handle) {
        return await fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    getImage(handleActive) {
        this.getProductData(handleActive).then((data) => {
            console.log('la data', data)
            if(data) {
                let featuredImage = data.featured_image;
                if(featuredImage == null || featuredImage == '' || featuredImage == undefined) {
                    featuredImage = (data.images.length > 0 ? data.images[0] : data.featured_image);
                }


                this.appendImage(featuredImage, data.id);
            }
        });
    }

    appendImage(featuredImage, id) {

        let thumbs = document.querySelectorAll('.media__thumb__holder .media__thumb__wrapper .media__thumb[super_image_smg="do"]'),
        slides = document.querySelectorAll('.product__grid--slides .flickity-slider .product__media[super_image_smg="do"]');
        if(thumbs.length > 0 && slides.length > 0) {
            this.mediaSlides.forEach((slide) => {
                if(slide.getAttribute('super_image_smg')) {
                    slide.setAttribute('data-media-src-placeholder', featuredImage);
                    slide.setAttribute('data-type', 'image');
                    document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="do"] img').setAttribute('srcset', `
                        ${featuredImage}&amp;width=352 352w,  ${featuredImage}?v=1708818227&amp;width=400 400w,  ${featuredImage}?v=1708818227&amp;width=768 768w,  ${featuredImage}?v=1708818227&amp;width=932 932w,  ${featuredImage}?v=1708818227&amp;width=1024 1024w,  ${featuredImage}?v=1708818227&amp;width=1200 1200w,  ${featuredImage}?v=1708818227&amp;width=1920 1920w, ${featuredImage}?v=1708818227&amp;width=2707 2707w
                    `);
                    document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="do"] img').setAttribute('sizes', '(min-width: 1100px) 70vw, (min-width: 768px) 50vw, calc(85vw - 20px)');
                    document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="do"] img').setAttribute('src', featuredImage);
                    
                }
            });

            
            this.mediaThumbs.forEach((thumb) => {
                if(thumb.getAttribute('super_image_smg')) {
                    document.querySelector('.media__thumb__holder .media__thumb__wrapper .media__thumb[super_image_smg="do"] img').setAttribute('src', featuredImage);
                    thumb.click();
                }
            });
        } else {
            //slide
            let mediaelement = document.createElement('div');
            mediaelement.classList.add('product__media', 'flickity-cell', 'is-selected');
            mediaelement.setAttribute('super_image_smg', 'do');
            mediaelement.setAttribute('data-media-slide', '');
            mediaelement.setAttribute('data-media-id', id);
            mediaelement.setAttribute('data-media-src-placeholder', featuredImage);
            mediaelement.setAttribute('data-type', 'image');
            mediaelement.setAttribute('aria-label', '');
            mediaelement.setAttribute('data-image-filter', '');
            mediaelement.setAttribute('data-aspect-ratio', '1.0');
            mediaelement.setAttribute('aria-hidden', 'true');
            mediaelement.setAttribute('style', 'transform: translateX(-50%); opacity: 1;');
            mediaelement.innerHTML = `
                <div>
                    <div class="lazy-image mobile-zoom-wrapper">
                        <img src="${featuredImage}" alt="" width="" height="" loading="lazy" class="tw-block tw-overflow-hidden tw-object-cover tw-w-full tw-h-full"
                        srcset="${featuredImage}&amp;width=352 352w,  ${featuredImage}?v=1708818227&amp;width=400 400w,  ${featuredImage}?v=1708818227&amp;width=768 768w,  ${featuredImage}?v=1708818227&amp;width=932 932w,  ${featuredImage}?v=1708818227&amp;width=1024 1024w,  ${featuredImage}?v=1708818227&amp;width=1200 1200w,  ${featuredImage}?v=1708818227&amp;width=1920 1920w, ${featuredImage}?v=1708818227&amp;width=2707 2707w"
                        sizes="(min-width: 1100px) 70vw, (min-width: 768px) 50vw, calc(85vw - 20px)" fetchpriority="auto" style="object-position: center center;">
                    </div>
                </div>
            `;

            //thumb
            let thumb = document.createElement('div');
            thumb.classList.add('media__thumb', 'is-activated');
            thumb.setAttribute('super_image_smg', 'do');
            thumb.setAttribute('data-slideshow-thumbnail', '');
            thumb.setAttribute('data-media-select', id);
            thumb.setAttribute('data-aspect-ratio', '1.0');
            thumb.setAttribute('aria-label', '');
            thumb.setAttribute('data-image-filter', '');

            thumb.innerHTML = `<img loading="lazy" class="" src="${featuredImage}" alt=""/>`;

            document.querySelector('.media__thumb__holder .media__thumb__wrapper').appendChild(thumb);
            document.querySelector('.product__grid--slides .flickity-slider').appendChild(mediaelement);

            document.querySelectorAll('.media__thumb__holder .media__thumb__wrapper .media__thumb').forEach((_thumb) => {
                _thumb.addEventListener('click', (evt) => {

                    if(evt.currentTarget.getAttribute('super_image_smg')) {
                        document.querySelector('.media__thumb__holder .media__thumb__wrapper .media__thumb.is-activated:not([super_image_smg="do"])').classList.remove('is-activated');
                        evt.currentTarget.classList.add('is-activated');

                        document.querySelector('.product__grid--slides .flickity-slider .product__media.is-selected:not([super_image_smg="do"])').classList.remove('is-selected');
                        document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="do"]').classList.add('is-selected');
                    } else {
                        if(document.querySelectorAll('.media__thumb__holder .media__thumb__wrapper .media__thumb[super_image_smg="do"]').length > 0) {
                            document.querySelector('.media__thumb__holder .media__thumb__wrapper .media__thumb[super_image_smg="do"]').classList.remove('is-activated');
                            document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="do"]').classList.remove('is-selected');
                            document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="do"]').setAttribute('style', 'transform: translateX(-50%); opacity: 0;');
                        }

                        evt.currentTarget.classList.add('is-activated');
                    }
                });
            });
        }
    }

    initDeliveryPackageSelector() {
        console.log('🔧 Initializing delivery package selector');
        const deliveryPackageOptions = document.querySelectorAll('.package-option[data-product-id]');
        console.log('📦 Packages found:', deliveryPackageOptions.length);
        
        if (deliveryPackageOptions.length > 0) {
            deliveryPackageOptions.forEach((option, index) => {
                console.log(`📦 Setting up package ${index + 1}:`, option);
                const radioButton = option.querySelector('input[type="radio"]');
                console.log('🔘 Radio button found:', radioButton);
                
                if (radioButton) {
                    // Hacer toda la caja clickeable
                    option.addEventListener('click', (e) => {
                        console.log('🖱️ Click on package box:', option);
                        this.handleDeliveryPackageClick(option, radioButton);
                    });
                    
                    // También escuchar cambios en el radio button
                    radioButton.addEventListener('change', (e) => {
                        console.log('🔘 Radio button change:', e.target);
                        this.handleDeliveryPackageSelection(e);
                    });
                } else {
                    console.warn('⚠️ Radio button not found in:', option);
                }
            });
        } else {
            console.warn('⚠️ No delivery packages found');
        }
    }

    handleDeliveryPackageClick(packageOption, radioButton) {
        console.log('🎯 Handling package click:', packageOption);
        console.log('🔘 Radio button before:', radioButton.checked);
        
        // Si ya está seleccionado, deseleccionarlo; si no, seleccionarlo
        if (radioButton.checked) {
            console.log('🔄 Deselecting already selected package');
            radioButton.checked = false;
        } else {
            console.log('✅ Selecting new package');
            radioButton.checked = true;
        }
        
        console.log('🔘 Radio button after:', radioButton.checked);
        
        // Actualizar estilos visuales
        this.updatePackageSelection();
    }

    handleDeliveryPackageSelection(event) {
        console.log('🔄 Handling selection change:', event.target);
        // Actualizar estilos visuales cuando cambia la selección
        this.updatePackageSelection();
    }

    updatePackageSelection() {
        console.log('🎨 Updating visual styles');
        const allPackageOptions = document.querySelectorAll('.package-option[data-product-id]');
        console.log('📦 Total packages to update:', allPackageOptions.length);
        
        allPackageOptions.forEach((option, index) => {
            const radioButton = option.querySelector('input[type="radio"]');
            console.log(`📦 Package ${index + 1} - Radio checked:`, radioButton?.checked);
            
            if (radioButton && radioButton.checked) {
                console.log(`✅ Selecting package ${index + 1}`);
                option.classList.add('selected');
            } else {
                console.log(`❌ Deselecting package ${index + 1}`);
                option.classList.remove('selected');
            }
        });
    }

    getSelectedDeliveryPackage() {
        console.log('🔍 Looking for selected delivery package');
        const selectedRadioButton = document.querySelector('.package-option input[type="radio"]:checked');
        console.log('🔘 Selected radio button found:', selectedRadioButton);
        
        if (selectedRadioButton) {
            const packageOption = selectedRadioButton.closest('.package-option');
            console.log('📦 Selected package:', packageOption);
            
            const packageData = {
                id: packageOption.dataset.productId,
                variantId: packageOption.dataset.variantId,
                price: packageOption.dataset.price,
                handle: packageOption.dataset.handle
            };
            console.log('📋 Package data:', packageData);
            return packageData;
        }
        console.log('❌ No package selected');
        return null;
    }

    // Modal Chiller: inicialización de eventos
    initChillerModal() {
        console.log('[ChillerModal] Initializing modal listeners');
        const modalSection = this.getChillerModalSection();
        if (!modalSection) {
            console.warn('⚠️ Modal chiller section not found (.product-modal-chiller_section)');
            // No retornamos, porque igualmente queremos registrar handlers de apertura para cuando aparezca
        }

        // Botones para abrir dentro del componente
        const openButtons = this.querySelectorAll('.open-modal, .open_modal-chiller, .open-modal-chiller');
        console.log(`[ChillerModal] Open buttons found: ${openButtons.length}`, openButtons);
        openButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                console.log('[ChillerModal] Open button clicked:', btn);
                this.openChillerModal();
            });
        });

        // Cerrar con botones dentro del modal
        const currentModal = this.getChillerModalSection();
        console.log('currentModal', currentModal);
        const closeBtn = currentModal?.querySelector('.close-modal');
        const closeCta = currentModal?.querySelector('.btn-close-modal');
        if (closeBtn) {
            console.log('[ChillerModal] Close button found (.close-modal)');
            closeBtn.addEventListener('click', () => {
                console.log('[ChillerModal] Close button clicked');
                this.closeChillerModal();
            });
        }
        if (closeCta) {
            console.log('[ChillerModal] Close CTA found (.btn-close-modal)');
            closeCta.addEventListener('click', () => {
                console.log('[ChillerModal] Close CTA clicked');
                this.closeChillerModal();
            });
        }

        // Cerrar por delegación: botones internos y overlay, y manejar acordeón
        currentModal?.addEventListener('click', (e) => {
            const target = e.target;
            const closeTrigger = target.closest?.('.close-modal, .btn-close-modal');
            if (closeTrigger) {
                e.preventDefault();
                console.log('[ChillerModal] Close trigger clicked:', closeTrigger);
                this.closeChillerModal();
                return;
            }
            // Toggle acordeón: buscar el header del acordeón correctamente
            const accordionTitle = target.closest?.('.title-item');
            if (accordionTitle) {
                const item = accordionTitle.closest('.modal-accordion-item');
                if (item) {
                    const content = item.querySelector('.list-description-item');
                    const willOpen = !item.classList.contains('active');
                    if (!content) {
                        console.warn('[ChillerModal] Accordion content not found (.list-description-item)');
                    }
                    item.classList.toggle('active');
                    if (content) {
                        if (willOpen) {
                            // Force reflow and set target height
                            const full = content.scrollHeight;
                            console.log('[ChillerModal] Accordion open: scrollHeight=', full);
                            content.style.visibility = 'visible';
                            content.style.opacity = '1';
                            content.style.maxHeight = full + 'px';
                        } else {
                            console.log('[ChillerModal] Accordion close');
                            content.style.opacity = '0';
                            content.style.maxHeight = '0px';
                            // After transition, hide for accessibility
                            const onEnd = (evt) => {
                                if (evt.propertyName === 'max-height') {
                                    content.style.visibility = 'hidden';
                                    content.removeEventListener('transitionend', onEnd);
                                }
                            };
                            content.addEventListener('transitionend', onEnd);
                        }
                    }
                    console.log('[ChillerModal] Accordion toggled:', willOpen ? 'open' : 'close', item);
                }
                e.preventDefault();
                return;
            }
            // Overlay (clic fuera del contenedor)
            if (e.target === currentModal) {
                console.log('[ChillerModal] Overlay clicked');
                this.closeChillerModal();
            }
        }, true);

        // Cerrar con tecla ESC
        document.addEventListener('keydown', (e) => {
            const m = this.getChillerModalSection();
            if (e.key === 'Escape' && m && m.classList.contains('active')) {
                console.log('[ChillerModal] ESC pressed');
                this.closeChillerModal();
            }
        });

        // Re-inicializar cuando Shopify recarga secciones en el editor
        if (!this._chillerShopifyReloadBound) {
            this._chillerShopifyReloadBound = true;
            document.addEventListener('shopify:section:load', (ev) => {
                console.log('[ChillerModal] shopify:section:load', ev?.detail);
                // Reintentar el setup al recargarse cualquier sección
                setTimeout(() => this.initChillerModal(), 0);
            });
        }

        // Delegación global (fallback): cerrar modal desde documento
        if (!this._chillerDocClickBound) {
            this._chillerDocClickBound = true;
            document.addEventListener('click', (e) => {
                const modal = this.getChillerModalSection();
                if (!modal || !modal.classList.contains('active')) return;

                const closeTrigger = e.target.closest?.('.product-modal-chiller_section .close-modal, .product-modal-chiller_section .btn-close-modal');
                if (closeTrigger) {
                    e.preventDefault();
                    console.log('[ChillerModal] Document delegation close trigger clicked:', closeTrigger);
                    this.closeChillerModal();
                    return;
                }
                if (e.target === modal) {
                    console.log('[ChillerModal] Document delegation overlay clicked');
                    this.closeChillerModal();
                }
            }, true);
        }

        // Delegación global: abrir modal desde cualquier botón con .open-modal, .open_modal-chiller o .open-modal-chiller
        if (!this._chillerDocOpenBound) {
            this._chillerDocOpenBound = true;
            document.addEventListener('click', (e) => {
                const opener = e.target.closest?.('.open-modal, .open_modal-chiller, .open-modal-chiller');
                if (opener) {
                    e.preventDefault();
                    console.log('[ChillerModal] Document delegation open clicked:', opener);
                    this.openChillerModal();
                }
            }, true);
        }
    }

    getChillerModalSection() {
        return document.querySelector('.product-modal-chiller_section');
    }

    async openChillerModal() {
        let modalSection = this.getChillerModalSection();
        if (!modalSection) {
            console.warn('⚠️ Chiller modal not found. Attempting to load section dynamically…');
            try {
                modalSection = await this.ensureChillerModalPresent();
            } catch (err) {
                console.error('[ChillerModal] Failed to load modal section:', err);
                return;
            }
            if (!modalSection) {
                console.warn('⚠️ Cannot open chiller modal: section .product-modal-chiller_section still not found after load');
                return;
            }
        }
        console.log('[ChillerModal] Opening modal');
        modalSection.classList.add('active');
        // Evitar scroll del body cuando el modal esté abierto
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        // Re-bind direct listeners every time we open (por si la sección se re-renderizó)
        const closeBtn = modalSection.querySelector('.close-modal');
        const closeCta = modalSection.querySelector('.btn-close-modal');
        if (closeBtn && !closeBtn._chillerBound) {
            console.log('[ChillerModal] Binding direct listener to .close-modal');
            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                console.log('[ChillerModal] .close-modal clicked (direct)');
                this.closeChillerModal();
            }, true);
            closeBtn._chillerBound = true;
        }
        if (closeCta && !closeCta._chillerBound) {
            console.log('[ChillerModal] Binding direct listener to .btn-close-modal');
            closeCta.addEventListener('click', (e) => {
                e.preventDefault();
                console.log('[ChillerModal] .btn-close-modal clicked (direct)');
                this.closeChillerModal();
            }, true);
            closeCta._chillerBound = true;
        }
    }

    async ensureChillerModalPresent() {
        const existing = this.getChillerModalSection();
        if (existing) return existing;
        const url = `${window.location.pathname}?section_id=product-modal-chiller`;
        console.log('[ChillerModal] Fetching section:', url);
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();
        const temp = document.createElement('div');
        temp.innerHTML = html;

        // Inject section styles if present
        const sectionStyles = temp.querySelectorAll('style, link[rel="stylesheet"]');
        sectionStyles.forEach((node) => {
            try {
                if (node.tagName === 'STYLE') {
                    // Avoid duplicates by content hash check (basic)
                    const content = node.textContent?.trim();
                    if (content && !document.head.textContent?.includes(content)) {
                        const clone = document.createElement('style');
                        clone.textContent = content;
                        document.head.appendChild(clone);
                    }
                } else if (node.tagName === 'LINK') {
                    const href = node.getAttribute('href');
                    if (href && !document.head.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
                        const link = document.createElement('link');
                        link.rel = 'stylesheet';
                        link.href = href;
                        document.head.appendChild(link);
                    }
                }
            } catch (e) {
                console.warn('[ChillerModal] Failed to inject section style/link', e);
            }
        });

        const modal = temp.querySelector('.product-modal-chiller_section');
        if (!modal) {
            console.warn('[ChillerModal] Section fetched but modal root not found');
            return null;
        }
        document.body.appendChild(modal);
        console.log('[ChillerModal] Modal section injected into DOM');
        return modal;
    }

    closeChillerModal() {
        const modalSection = this.getChillerModalSection();
        if (!modalSection) return;
        console.log('[ChillerModal] Closing modal');
        modalSection.classList.remove('active');
        // Restaurar scroll
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
    }

}

customElements.define(ProductUpsellNew.name, ProductUpsellNew);